module.exports = __webpack_public_path__ + "img/humanities-arts.5e7e6ad5.svg";